export default "__VITE_ASSET__DI6m0pAm__"